export default "__VITE_ASSET__Dkg_ZfQ9__"